import k2 from "../Assets/Images/K2.jpg";
import broadPeak from "../Assets/Images/Broad Peak.jpg";
import gasherbrumI from "../Assets/Images/Gasherbrum I.jpg";
import gasherbrumII from "../Assets/Images/Gasherbrum II.jpg";
import nangaParbat from "../Assets/Images/Nanga Parbat.jpg";

export const ContentData = [
  {
    detail:
      "K2 also known as Mount Godwin-Austen or Chhogori, at 8,611 metres (28,251 ft) above sea level, is the second highest mountain in the world, after Mount Everest at 8,848 metres (29,029 ft). It is located on the China–Pakistan border between Baltistan in the Gilgit-Baltistan region of northern Pakistan, and the Taxkorgan Tajik Autonomous County of Xinjiang, China. K2 is the highest point of the Karakoram range and the highest point in both Pakistan and Xinjiang.",
    img: k2,
    imgName: "Figure: K2 (Karakoram 2)",
  },
  {
    detail:
      'Broad Peak is the 12th highest mountain in the world at 8,047 metres (26,401 ft) above sea level. The literal translation of "Broad Peak" to Falchan Kangri is not used among the Balti people. The English name was introduced in 1892 by the British explorer Martin Conway, in reference to the similarly named Breithorn in the Alps.',
    img: broadPeak,
    imgName: "Figure: Broad Peak",
  },
  {
    detail:
      'Gasherbrum I surveyed as K5 and also known as Hidden Peak, is the 11th highest mountain in the world at 8,080 metres (26,510 ft) above sea level. It is located on the Pakistan–Chinese border and Xinjiang region of China. Gasherbrum I is part of the Gasherbrum massif, located in the Karakoram region of the Himalaya. Gasherbrum is often claimed to mean "Shining Wall", presumably a reference to the highly visible face of the neighboring peak Gasherbrum IV; but in fact it comes from "rgasha" (beautiful) + "brum" (mountain) in Balti, hence it actually means "beautiful mountain."',
    img: gasherbrumI,
    imgName: "Figure: Gasherbrum I",
  },
  {
    detail:
      "Gasherbrum II surveyed as K4, is the 13th highest mountain in the world at 8,035 metres (26,362 ft) above sea level. It is the third-highest peak of the Gasherbrum massif, and is located in the Karakoram, on the border between Gilgit–Baltistan province, Pakistan, and Xinjiang, China. The mountain was first climbed on July 7, 1956, by an Austrian expedition which included Fritz Moravec, Josef Larch, and Hans Willenpart.",
    img: gasherbrumII,
    imgName: "Figure: Gasherbrum II",
  },
  {
    detail:
      'Nanga Parbat locally known as Diamer, is the ninth highest mountain in the world at 8,126 metres (26,660 ft) above sea level. Located in the Diamer District of Pakistan’s Gilgit Baltistan region, Nanga Parbat is the western anchor of the Himalayas. The name Nanga Parbat is derived from the Sanskrit words nagna and parvata which together mean "Naked Mountain". The mountain is locally known by its Tibetan name Diamer or Deo Mir, meaning "huge mountain".',
    img: nangaParbat,
    imgName: "Figure: Nanga Parbat",
  },
];
